import { ReportFileItem, ReportThumbnailItem } from '@/server/services/GoogleCloudBuckets/GoogleCloudBuckets.types';
import { ROUTE, axiosInstance } from './axiosInstance';

export const reports = {
  getReportsList: async () => {
    const { data } = await axiosInstance.get<ReportFileItem[]>(ROUTE.REPORTS.LIST);
    return data;
  },

  uploadFile: async (payload: {
    file: File;
    folderPath: string;
    onUploadProgress?: (event: { loaded: number; total?: number }) => void;
    signal?: AbortSignal;
  }) => {
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('folderPath', payload.folderPath);

    const { data } = await axiosInstance.post<{ success: boolean; name: string }>(ROUTE.REPORTS.UPLOAD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 0,
      signal: payload.signal,
      onUploadProgress: payload.onUploadProgress
        ? (event) => payload.onUploadProgress!({ loaded: event.loaded, total: event.total })
        : undefined,
    });
    return data;
  },

  deleteFile: async (payload: Pick<ReportFileItem, 'name'>) => {
    const { data } = await axiosInstance.post<{ success: boolean }>(ROUTE.REPORTS.DELETE, payload);
    return data;
  },

  renameFile: async (payload: Pick<ReportFileItem, 'name'> & { newName: string }) => {
    const { data } = await axiosInstance.post<{ success: boolean; name: string }>(
      ROUTE.REPORTS.RENAME,
      payload,
    );
    return data;
  },

  getSignedUrl: async (payload: Pick<ReportFileItem, 'name'> & { asAttachment?: boolean }) => {
    const { data } = await axiosInstance.post<{ signedUrl: string }>(ROUTE.REPORTS.DOWNLOAD_URL, payload);
    return data;
  },

  getReportThumbnail: async (payload: { thumbnailName: ReportThumbnailItem['name'] }) => {
    const { data } = await axiosInstance.get<{ imageSrc: string }>(ROUTE.REPORTS.THUMBNAIL, {
      params: { thumbnailName: payload.thumbnailName },
    });
    return data;
  },

  getPdfAsHtml: async (payload: { fileUrl: string }) => {
    const { data } = await axiosInstance.post<{ html: string }>(ROUTE.REPORTS.PDF_HTML, payload);
    return data;
  },
};
